import axios from "@/api/axios";
import {
  initAdminPushNotifications,
  clearAdminFcmToken,
  resetAdminPushNotifications,
} from "@/services/firebase";
import { useNotificationStore } from "@/stores/notification";

const login = async (credentials) => {
  const response = await axios.post("/auth/login", credentials);

  const data = response.data?.data;

  if (data?.token) {
    localStorage.setItem("admin_token", data.token);
  }

  if (data?.user) {
    localStorage.setItem("admin_user", JSON.stringify(data.user));
  }

  const notificationStore = useNotificationStore();

  initAdminPushNotifications().catch((error) => {
    console.error("FCM initialization after login failed:", error);
  });
  await notificationStore.init();

  return response;
};

const logout = async () => {
  const notificationStore = useNotificationStore();

  try {
    // Call backend logout to log activity and invalidate token
    await axios.post("/auth/logout");
  } catch (error) {
    console.error("Backend logout failed:", error);
  }

  try {
    await clearAdminFcmToken();
  } finally {
    resetAdminPushNotifications();
    notificationStore.reset();
    localStorage.removeItem("admin_token");
    localStorage.removeItem("admin_user");
  }
};

const getUser = () => {
  try {
    return JSON.parse(localStorage.getItem("admin_user"));
  } catch {
    return null;
  }
};

const isAuthenticated = () => {
  return !!localStorage.getItem("admin_token");
};

const getToken = () => {
  return localStorage.getItem("admin_token") || null;
};

export default {
  login,
  logout,
  getUser,
  isAuthenticated,
  getToken,
};
